import {
  AddIdentifyActionTypes,
  GetPatientDemographicsState,
  ADD_IDENTIFY_SUCCESS,
  ADD_IDENTIFY_LOADING,
  ADD_IDENTIFY_FAIL,
} from "./ActionTypes";
import { AddIdentifyResponse } from "./Model";

const initialStateGetPosts: GetPatientDemographicsState = {
  loading: false,
  addIdentify: {} as AddIdentifyResponse,
};
export const addIdentifyReducer = (
  state = initialStateGetPosts,
  action: AddIdentifyActionTypes
): GetPatientDemographicsState => {
  switch (action.type) {
    case ADD_IDENTIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        addIdentify: action.payload,
      };
    case ADD_IDENTIFY_LOADING:
      return {
        ...state,
        loading: true,
        addIdentify: {} as AddIdentifyResponse,
      };
    case ADD_IDENTIFY_FAIL:
      return {
        ...state,
        addIdentify: {} as AddIdentifyResponse,
        loading: false,
      };
    default:
      return state;
  }
};
